// welcome to hell
// this sick-ass custom function makes a 2d array of all possible winning combinations (in tic tac toe, obviously) based on game parameters
function generateWinArray(width, height, winLength) {
    // Define templates to use for calculations and main array (which will be returned)
    let horizontalTempArr = [];
    let verticalTempArr = [];
    let diag1TempArr = [];
    let diag2TempArr = [];
    let mainArr = [];
    // ADD HORIZONTAL WINS TO ARRAY
    // Set up template for horizontal win
    for(i = 0; i < winLength; i++)horizontalTempArr.push(i);
    // Do this for every row
    for(row = 0; row < height; row++)// Do this for each win-sized group that can fit in the row
    for(group = 0; group <= width - winLength; group++)// Convert the win group to a new array, and add it to the main collection of winning combos
    mainArr.push(addToArr(horizontalTempArr, group, row, width));
    // ADD VERTICAL WINS TO ARRAY
    // Set up template for vertical win
    for(i = 0; i < winLength; i++)verticalTempArr.push(i * width);
    // Do this for every column
    for(col = 0; col < width; col++)// Do this for each win-sized group that can fit in the column
    for(group = 0; group <= height - winLength; group++)// Convert the win group to a new array, and add it to the main collection of winning combos
    mainArr.push(addToArr(verticalTempArr, col, group, width));
    // ADD DOWN-RIGHT (top-left to bottom-right) DIAGS TO ARRAY
    // Set up template for y=-mx+b win
    for(i = 0; i < winLength; i++)diag1TempArr.push(i * width + i);
    // Do this for every column which can legally contain the start of a down-right diag win
    for(col = 0; col <= width - winLength; col++)// Do this for each win-sized group that can fit in the column
    for(group = 0; group <= height - winLength; group++)// Convert the win group to a new array, and add it to the main collection of winning combos
    mainArr.push(addToArr(diag1TempArr, col, group, width));
    // ADD DOWN-LEFT (top-right to bottom-left) DIAGS TO ARRAY
    // Set up template for y=-mx+b win
    for(i = 1; i <= winLength; i++)diag2TempArr.push(i * width - i);
    // Do this for every column which can legally contain the start of a down-left diag win
    for(col = 0; col <= width - winLength; col++)// Do this for each win-sized group that can fit in the column
    for(group = 0; group <= height - winLength; group++)// Convert the win group to a new array, and add it to the main collection of winning combos
    mainArr.push(addToArr(diag2TempArr, -col, group, width));
    return mainArr;
}
//console.log(generateWinArray(10, 10, 10));
// very important (parameterization?) for the main generator function -- this operation gets performed a LOT of times
function addToArr(arr, num1, num2, mult) {
    superTempArr = [];
    arr.forEach((num)=>{
        superTempArr.push(num + num1 + num2 * mult);
    });
    return superTempArr;
} // OLD STUPID WAY OF DOING THINGS -- NEVER DO THIS AGAIN
 // should be 28 total -- hardcoding them is just easier for now (not anymore lol rip)
 //const WINNING_COMBINATIONS_5x5_4 = [
 //    // HORIZONTAL WINS
 //    [0, 1, 2, 3],
 //    [1, 2, 3, 4],
 //    [5, 6, 7, 8],
 //    [6, 7, 8, 9],
 //    [10, 11, 12, 13],
 //    [11, 12, 13, 14],
 //    [15, 16, 17, 18],
 //    [16, 17, 18, 19],
 //    [20, 21, 22, 23],
 //    [21, 22, 23, 24],
 //    // VERTICAL WINS
 //    [0, 5, 10, 15],
 //    [5, 10, 15, 20],
 //    [1, 6, 11, 16],
 //    [6, 11, 16, 21],
 //    [2, 7, 12, 17],
 //    [7, 12, 17, 22],
 //    [3, 8, 13, 18],
 //    [8, 13, 18, 23],
 //    [4, 9, 14, 19],
 //    [9, 14, 19, 24],
 //    // DOWN-RIGHT (negative slope) DIAG WINS
 //    [0, 6, 12, 18],
 //    [6, 12, 18, 24],
 //    [1, 7, 13, 19],
 //    [5, 11, 17, 23],
 //    // DOWN-LEFT (positive slope) DIAG WINS
 //    [4, 8, 12, 16],
 //    [8, 12, 16, 20],
 //    [3, 7, 11, 15],
 //    [9, 13, 17, 21],
 //]
 // only 9 ways to win -- literally a piece of cake
 //const WINNING_COMBINATIONS_3x3_3 = [
 //    [0, 1, 2],
 //    [3, 4, 5],
 //    [6, 7, 8],
 //    [0, 3, 6],
 //    [1, 4, 7],
 //    [2, 5, 8],
 //    [0, 4, 8],
 //    [2, 4, 6]
 //]
 // MAKING THIS TO TEST THE NEW MAGIC FUNCTION
 //const WINNING_COMBINATIONS_4x9_4 = [
 //    // HORIZONTAL WINS
 //    [0, 1, 2, 3],
 //    [4, 5, 6, 7],
 //    [8, 9, 10, 11],
 //    [12, 13, 14, 15],
 //    [16, 17, 18, 19],
 //    [20, 21, 22, 23],
 //    [24, 25, 26, 27],
 //    [28, 29, 31, 31],
 //    [32, 33, 34, 35]
 // + 24 VERTICAL WINS
 // + 6 DOWN-RIGHT DIAG WINS
 // + 6 DOWN-LEFT DIAG WINS
 //]

//# sourceMappingURL=tictactoe.582cdb78.js.map
